export default __webpack_public_path__ + "static/Plots0113-283784506eafcb89dcfc4c001aea6dfd.jpg";